import {IResponse, requestWithToken} from "./RequestBase";
import {config} from "../config";
import {IPerson} from "../store/slicePerson";
import {store} from "../store/configureStore";
import {actions as actionsPerson} from "../store/slicePerson";
import {actions as modal} from "../store/sliceModal";
import {IUser} from "../store/sliceUser";

export const fetchAllUsers = async (): Promise<IResponse> => {
    const data: IResponse = await requestWithToken(`${config.authUrl}/api/admin/all`,
        {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            }
        },
        false,
        true
    );

    if (data.status === 401) {
        store.dispatch(modal.showError("Отказано в доступе"))
    }

    return data;
}

export const fetchRoles = async (): Promise<IResponse> => {
    const data: IResponse = await requestWithToken(`${config.authUrl}/api/admin/roles`,
        {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            }
        },
        false,
        true
    );

    if (data.status === 401) {
        store.dispatch(modal.showError("Отказано в доступе"))
    }

    return data;
}

export const fetchUser = async (id: number): Promise<IResponse> => {
    const data: IResponse = await requestWithToken(`${config.authUrl}/api/admin/${id}`,
        {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
            }
        },
        false,
        true
    );

    if (data.status === 401) {
        store.dispatch(modal.showError("Отказано в доступе"))
    }

    return data;
}

export const deleteUser = async (id: number): Promise<IResponse> => {
    const data: IResponse = await requestWithToken(`${config.authUrl}/api/admin/${id}`,
        {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json',
            }
        },
        false,
        true
    );
    return data;
}

export const updateUser = async (user: IUser, password?: string): Promise<IResponse> => {
    const data: IResponse = await requestWithToken(`${config.authUrl}/api/admin/update/user`,
        {
            method: "PUT",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: user.id,
                name: user.name,
                login: user.login,
                email: user.email,
                roles: user.roles,
                password: password,
                f2Auth: user.f2Auth
            })
        },
        false,
        true
    );

    return data;
}
